import sumsubWebSdk from '@sumsub/websdk'
import { useAtom } from 'jotai'
import { useEffect } from 'react'
import {
  createSumsubKYCSession,
  getSumsubKYCSessionAccessToken,
} from 'src/common/api-clients/swarm/passport'
import { thirdwebClient } from 'src/common/api-clients/thirdweb'
import useTier2 from 'src/common/queries/useTier2'
import Modal from 'src/common/ui-kit/Modal'
import { kycModalAtom } from 'src/pages/TradePage/stores/trade-store'
import { getUserEmail } from 'thirdweb/wallets'

const KycModal = () => {
  const [kycModal, setKycModal] = useAtom(kycModalAtom)
  const { refetch } = useTier2()

  useEffect(() => {
    async function launchWebSdk() {
      const accessToken = (await createSumsubKYCSession('carbon')).data
        .attributes.token
      const email = await getUserEmail({
        client: thirdwebClient,
      })
      const sumsubWebSdkInstance = sumsubWebSdk
        .init(accessToken, () => getSumsubKYCSessionAccessToken('carbon'))
        .withConf({
          lang: 'en',
          email,
        })
        .onMessage((type: string, data) => {
          if (type === 'idCheck.onApplicantSubmitted') {
            if (
              (data as { reviewStatus: string }).reviewStatus === 'completed'
            ) {
              refetch()
            }
            // setTimeout(onSuccess, APPLICATION_SUBMITTED_MESSAGE_VISIBLE_TIME)
          }
        })
        .build()

      sumsubWebSdkInstance.launch('#sumsub-kyc-websdk-container')
    }

    if (kycModal) {
      launchWebSdk()
    }
  }, [kycModal, refetch])

  return (
    <Modal open={kycModal} onClose={() => setKycModal(false)} fullscreen>
      <div id='sumsub-kyc-websdk-container' />
    </Modal>
  )
}

export default KycModal
